import Vue from "vue";
import Component from "vue-class-component";
import { ICategoryRepo } from "@/entity/category/category.types";
import { ClientCategoryStore } from "@/store/modules/ClientsCategory";

@Component
export class ClientsCategoryMix extends Vue {
    get category(): ICategoryRepo | null {
        return ClientCategoryStore.category;
    }
}
